import React from 'react';
import { X, ImageOff } from 'lucide-react';

/**
 * 图片选择弹窗 - 网格展示项目中的所有图片
 */
export default function ImagePickerModal({ images, onSelect, onClose }) {
  const overlayStyle = {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
  };

  const modalStyle = {
    background: 'var(--modal-surface)',
    borderRadius: 16,
    padding: 24,
    maxWidth: '80vw',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    minWidth: 400,
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: 'var(--text-primary)',
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gap: 12,
    overflowY: 'auto',
    maxHeight: '60vh',
    padding: 4,
  };

  const imageCardStyle = {
    aspectRatio: '1',
    borderRadius: 8,
    overflow: 'hidden',
    cursor: 'pointer',
    border: '2px solid transparent',
    transition: 'all 0.2s',
    background: 'var(--modal-input-bg)',
  };

  const emptyStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: 40,
    color: 'var(--text-muted)',
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={e => e.stopPropagation()}>
        <div style={headerStyle}>
          <h3 style={{ margin: 0, fontSize: 18 }}>选择封面图片</h3>
          <button
            onClick={onClose}
            style={{ background: 'transparent', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer' }}
          >
            <X size={24} />
          </button>
        </div>

        {images.length === 0 ? (
          <div style={emptyStyle}>
            <ImageOff size={48} strokeWidth={1} />
            <p>该项目暂无图片</p>
            <p style={{ fontSize: 12 }}>请先在图板中添加图片</p>
          </div>
        ) : (
          <>
            <p style={{ color: 'var(--text-secondary)', fontSize: 14, margin: 0 }}>
              点击选择一张图片作为项目封面（共 {images.length} 张）
            </p>
            <div style={gridStyle}>
              {images.map((img, idx) => (
                <div
                  key={idx}
                  style={imageCardStyle}
                  onClick={() => onSelect(img.url)}
                  onMouseEnter={e => {
                    e.currentTarget.style.borderColor = '#3b82f6';
                    e.currentTarget.style.transform = 'scale(1.02)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.borderColor = 'transparent';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  <img
                    src={img.url}
                    alt={img.title || '图片'}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
